import { render, staticRenderFns } from "./App.vue?vue&type=template&id=389d084f&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./App.vue?vue&type=style&index=1&id=389d084f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d084f",
  null
  
)

export default component.exports